import React, { useEffect, useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import DataTable from "./DataTable/DataTable";
import "./tokensettings.scss";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { Api_Url } from "../../../utils/ApiUrl";
import { toast } from "react-toastify";
import Loader from "../../../hooks/loader";
import useWeb3 from "../../../hooks/useWeb3";
import {
  getERC20Token,
  getMatchainContract,
  getRainInstitutionPreSaleContract,
} from "../../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";

import tokensPriceFeed from "../../../utils/PriceFeedData.json";
import { PROJECT_MAPPING_Fixed } from "../../../utils/Constants";
import { getContracts } from "../../../utils/getContracts";
import useAdminAllowed from "../../../hooks/userManagement/useAdminAllowed";
import useFileUpload from "../../../hooks/dataSenders/singleUpload";
import UseAddTokenAutomated from "../../../hooks/dataSenders/useAddTokenAuto";

const Tokensettings = () => {
  const { uploadFile } = useFileUpload();
  const { addTokenAutomated } = UseAddTokenAutomated();
  const [imageSrc, setImageSrc] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // 📌 Upload Function
  const onImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Size Validation (3MB)
    if (file.size > 3 * 1024 * 1024) {
      alert("File size must be less than 3MB");
      return;
    }

    // Format Validation
    if (!["image/jpeg", "image/png"].includes(file.type)) {
      alert("Only JPEG and PNG allowed!");
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setImageSrc(reader.result);
      setShowCropModal(true);
    };
  };

  // 📌 Crop Complete
  const onCropComplete = useCallback((_, areaPixels) => {
    setCroppedAreaPixels(areaPixels);
  }, []);

  // 📌 Crop Image Logic
  const getCroppedImg = async () => {
    const image = new Image();
    image.src = imageSrc;
    await new Promise((resolve) => (image.onload = resolve));

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = croppedAreaPixels.width;
    canvas.height = croppedAreaPixels.height;

    ctx.drawImage(
      image,
      croppedAreaPixels.x,
      croppedAreaPixels.y,
      croppedAreaPixels.width,
      croppedAreaPixels.height,
      0,
      0,
      croppedAreaPixels.width,
      croppedAreaPixels.height
    );

    return canvas.toDataURL("image/png");
  };

  // 📌 Save Crop
  const handleSave = async () => {
    const cropped = await getCroppedImg();
    setCroppedImage(cropped);
    setErrors((prev) => ({ ...prev, image: "" }));
    setZoom(1);
    setShowCropModal(false);
    setShowCropModal(false);
  };
  const CHAIN = parseInt(process.env.REACT_APP_CHAIN_ID, 10);

  const chainNetwork =
    CHAIN == 1 ? "mainnet" : CHAIN == 11155111 ? "testnet" : null;

  const val = localStorage.getItem("accessToken");
  const { account, chainId } = useWeb3React();
  console.log("chainId", chainId, CHAIN);
  const web3 = useWeb3();
  const [project, setProject] = useState(PROJECT_MAPPING_Fixed[0]?.value);
  const [selectedItem, setSelectedItem] = useState({
    imgSrc: PROJECT_MAPPING_Fixed[0]?.imageSrc,
    text: PROJECT_MAPPING_Fixed[0]?.value,
  });

  const [loader, setLoader] = useState(false);

  const [show, setShow] = useState(false);
  const [showAutoAdd, setShowAutoAdd] = useState(false);

  const [checkAdmin, isAdmin] = useAdminAllowed();

  const emptyTokenAddDetails = () => {
    setTokenDecimals("");
    setTokenName("");
    setTokenPriceFeed("");
    setNormalisationFactorNFT("");
    setNormalisationFactorToken("");
    setTokenSymbol("");
    setContractAddress("");
    setCmcSymbol("");
    setCmcUCID("");
    setTolerance("");
    setCroppedImage(null);
    setErrors({});
  };

  const handleClose = () => {
    setShow(false);
    emptyTokenAddDetails();
  };
  const handleShow = () => {
    setShow(true);
  };

  const handleCloseAutoAdd = () => {
    setShowAutoAdd(false);
    emptyTokenAddDetails();
  };
  const handleShowAutoAdd = () => {
    setShowAutoAdd(true);
  };

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [key, setKey] = useState("manualprivatesales");
  const [isAutomated, setIsAutomated] = useState(false);

  const [tokenData, setTokenData] = useState([]);
  const [autotokensData, setAutotokensData] = useState([]);
  const [search, setSearch] = useState("");
  const [automatedSearch, setAutomatedSearch] = useState("");

  const [orderField, setOrderField] = useState("");
  const [orderDirection, setOrderDirection] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [automatedOrderField, setAutomatedOrderField] = useState("");
  const [automatedOrderDirection, setAutomatedOrderDirection] = useState("");
  const [automatedstatusFilter, setAutomatedstatusFilter] = useState("");

  const [contractAddress, setContractAddress] = useState([]);
  const [tokenName, setTokenName] = useState("");

  const [tokenSymbol, setTokenSymbol] = useState("");
  const [tokenDecimals, setTokenDecimals] = useState("");
  const [normalisationFactorNFT, setNormalisationFactorNFT] = useState("");
  const [normalisationFactorToken, setNormalisationFactorToken] = useState("");
  const [tokenPriceFeed, setTokenPriceFeed] = useState("");
  const [tolerance, setTolerance] = useState("");
  const [cmcSymbol, setCmcSymbol] = useState("");
  const [cmcUCID, setCmcUCID] = useState("");

  const [errors, setErrors] = useState({});

  const handleItemClick = (imgSrc, text) => {
    setSelectedItem({ imgSrc, text });
    setProject(text);
  };

  const handleContractChange = async (e) => {
    try {
      let address = [e.target.value];
      setContractAddress(address);
      const contract = getERC20Token(e.target.value, web3);
      const name = await contract.methods.name().call();
      let symbol = await contract.methods.symbol().call();
      const decimals = await contract.methods.decimals().call();
      // console.log("token aname asdfasf : ", name, symbol, decimals);
      symbol = symbol === "MTK" ? "WETH" : symbol;
      setTokenName(name);
      setTokenSymbol(symbol);
      setTokenDecimals(decimals);
      // console.log("token aname asdsadfasdfasdffasf : ", name, symbol, decimals);
    } catch (error) {
      throw error;
    }

    // await axios
    //   .get("https://api.coingecko.com/api/v3/coins/list")
    //   .then((response) => {
    //     // Data contains an array of tokens with their details
    //     // console.log(response?.data);
    //     // Access each token's name, symbol, and icon using data[i].name, data[i].symbol, data[i].image
    //   })
    //   .catch((error) => console.error("Error fetching data:", error));
  };

  const connectwalletfirst = () => {
    toast.error("Please connect your wallet first ", {
      position: "top-right",
      autoClose: 3000,
    });
  };

  // useEffect(() => {
  //   tokenDataRegistry();
  // }, []);

  // const tokenDataRegistry = async () => {
  //   const tokdata = await timerNFT(
  //     "0x25762231808F040410586504fDF08Df259A2163c"
  //   );
  //   // console.log("token data from reg: ", tokdata);
  // };
  useEffect(() => {
    getTokenData();
  }, [search, orderField, orderDirection, statusFilter, project]);

  useEffect(() => {
    getAutomatedTokensData();
  }, [
    automatedSearch,
    automatedOrderField,
    automatedOrderDirection,
    automatedstatusFilter,
  ]);

  useEffect(() => {
    if (key === "automatedprivatesales") {
      setIsAutomated(true);
    }
    if (key === "manualprivatesales") {
      setIsAutomated(false);
    }
  }, [key]);

  const getTokenData = () => {
    setTokenData([]);
    var config = {
      method: "get",
      url: `${Api_Url}/tokens?limit=25&offset=1&privateSale=${project}`,

      headers: {
        Authorization: "Bearer " + val,
      },
    };
    let dynamicQuery = config.url;

    if (search) {
      dynamicQuery += `&search=${search}`;
    }
    if (orderField) {
      dynamicQuery += `&orderField=${orderField}&orderDirection=${orderDirection}`;
    }
    if (statusFilter == "active") {
      dynamicQuery += `&status=${true}`;
    } else if (statusFilter == "inactive") {
      dynamicQuery += `&status=${false}`;
    }
    config.url = dynamicQuery;
    axios(config)
      .then(function (res) {
        setTokenData(res?.data?.data?.tokens);

        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
      });
  };

  const getAutomatedTokensData = async () => {
    setAutotokensData([]);

    let orderfield = automatedOrderField || "createdAt";
    let orderdirection = automatedOrderDirection || "1";

    var config = {
      method: "get",
      url: `${Api_Url}/dynamic-tokens/all?limit=25&offset=1&orderField=${orderfield}&orderDirection=${orderdirection}`,

      headers: {
        Authorization: "Bearer " + val,
      },
    };

    let dynamicQuery = config.url;
    if (automatedSearch) {
      dynamicQuery += `&tokenContractAddress=${automatedSearch}`;
    }
    if (automatedstatusFilter == "active") {
      dynamicQuery += `&isActive=${true}`;
    } else if (automatedstatusFilter == "inactive") {
      dynamicQuery += `&isActive=${false}`;
    }
    config.url = dynamicQuery;

    axios(config)
      .then(function (res) {
        setAutotokensData(res?.data?.data?.data);

        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
      });
  };

  const toggleStatus = async (id) => {
    var config = {
      method: "patch",
      url: `${Api_Url}/tokens/${id}/toggle-status`,

      headers: {
        Authorization: "Bearer " + val,
      },
    };

    await axios(config)
      .then(function (res) {
        getTokenData();
        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
      });
  };

  const toggleStatusAutomated = async (id) => {
    var config = {
      method: "patch",
      url: `${Api_Url}/dynamic-tokens/${id}/toggle`,

      headers: {
        Authorization: "Bearer " + val,
      },
    };

    await axios(config)
      .then(function (res) {
        getAutomatedTokensData();
        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
      });
  };

  const addToken = async () => {
    setLoader(true);
    if (account) {
      if (ValidateForm()) {
        const data = {
          ...(tokenName && { name: tokenName }),
          address: contractAddress[0],
          symbol: tokenSymbol,
          decimal: tokenDecimals,
          privateSale: project,
        };
        var config = {
          method: "post",
          url: `${Api_Url}/tokens`,
          data: data,
          headers: {
            Authorization: "Bearer " + val,
          },
        };
        setLoader(true);
        await axios(config)
          .then(async (res) => {
            const resData = res?.data?.data;
            await setPriceFeed();
            getTokenData();
            setLoader(false);
          })
          .catch((err) => {
            // console.log("err response: ", err?.response);
            if (err?.response?.status == 409) {
              setPriceFeed();
              handleClose();
              handleShow1();
              setLoader(false);
              // toast.error(err?.response?.message);
            } else {
              setLoader(false);
            }
            toast.error(err?.response?.message);
          });
      }
    } else {
      connectwalletfirst();
    }
  };

  const base64ToFile = (base64String, filename = "image.png") => {
    // Remove the data:image/png;base64, part
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const addAutomatedToken = async () => {
    if (!account) {
      connectwalletfirst();
      return;
    }
    if (!ValidateForm()) return;

    const data = {
      tokenContractAddress: contractAddress[0],
      tokenSymbol,
      tokenDecimals,
      ucid: cmcUCID,
      tokenSymbolCmc: cmcSymbol,
      slippageTolerance: tolerance,
      priceFeedContract: tokenPriceFeed,
      normalizationFactorToken: normalisationFactorToken,
      normalizationFactorNft: normalisationFactorNFT,
    };
    console.log("waleed data to send", data);

    try {
      setLoader(true);
      const croppedFile = base64ToFile(croppedImage, "cropped-image.png");
      const imageUrl = await uploadFile(croppedFile, setLoader);

      const tokenData = { ...data, imageUrl };

      const res = await axios.post(`${Api_Url}/dynamic-tokens/add`, tokenData, {
        headers: {
          Authorization: "Bearer " + val,
        },
      });

      if (res) {
        const priceFeedData =
          project === "KAI"
            ? [
              [
                tokenPriceFeed,
                parseInt(normalisationFactorToken),
                parseInt(tolerance),
              ],
            ]
            : [
              [
                tokenPriceFeed,
                parseInt(normalisationFactorToken),
                parseInt(normalisationFactorNFT),
                parseInt(tolerance),
              ],
            ];
        const priceFeedRes = await addTokenAutomated(
          account,
          contractAddress,
          priceFeedData
        );
      }

      console.log("response from adding automated token: ", res);
      getAutomatedTokensData();
      handleCloseAutoAdd();
      handleShow1();
    } catch (err) {
      console.log("error while adding automated token: ", err);
      if (err?.response?.message) toast.error(err?.response?.message);
    } finally {
      setLoader(false);
    }
  };

  const setPriceFeed = async () => {
    // // console.log(
    //   "setting price feed: ",
    //   tokenPriceFeed,
    //   "----",
    //   parseInt(normalisationFactorToken),
    //   parseInt(normalisationFactorNFT),
    //   parseInt(tolerance)
    // );
    const { contract, contractInstitution } = getContracts(project, web3);
    // console.log(contract, contractInstitution, "contract and institution");

    // let contract, contractInstitution;
    // if (project == "RAIN") {
    //   contract = getRainPreSaleV3Contract(Environment.RainPreSaleV3, web3);
    //   contractInstitution = getRainInstitutionPreSaleContract(
    //     Environment.RainInstitutionPreSale,
    //     web3
    //   );
    // }
    // else if (project == "MATCHAIN") {
    //   contract = getMatchainContract(
    //     Environment.PreSale,
    //     web3
    //   );
    //   // contractInstitution = getNFAInstitutionPreSaleContract(
    //   //   Environment.NFAInstitutionPreSale,
    //   //   web3
    //   // );
    // } else if (project == "ASTRANOVA") {
    //   contract = getAstroNovaPreSaleV2Contract(
    //     Environment.AstroNovaPreSaleV2,
    //     web3
    //   );
    //   // contractInstitution = getNFAInstitutionPreSaleContract(
    //   //   Environment.NFAInstitutionPreSale,
    //   //   web3
    //   // );
    // } else if (project == "NFA") {
    //   contract = getNFAPreSaleContract(Environment.NFAPreSale, web3);
    //   // contractInstitution = getNFAInstitutionPreSaleContract(
    //   //   Environment.NFAInstitutionPreSale,
    //   //   web3
    //   // );
    // } else if (project == "LEIA") {
    //   contract = getLEIAPreSaleContract(Environment.LEIAPreSale, web3);
    //   contractInstitution = getLEIAInstitutionPreSaleContract(
    //     Environment.LEIAInstitutionPreSale,
    //     web3
    //   );
    // } else if (project == "OLYMPUS") {
    //   contract = getOlympusPreSaleContract(Environment.OlympusPreSale, web3);
    //   contractInstitution = getOlympusInstitutionPreSaleContract(
    //     Environment.OlympusInstitutionPreSale,
    //     web3
    //   );
    // } else if (project == "INCENTIV") {
    //   contract = getPreSaleContract(Environment.PreSale, web3);
    //   contractInstitution = getinstitutionpresalecontract(
    //     Environment.InstitutionPreSale,
    //     web3
    //   );
    // }

    try {
      let data =
        project === "MATCHAIN"
          ? [
            [
              tokenPriceFeed,
              // parseInt(normalisationFactorToken),
              parseInt(normalisationFactorNFT),
              parseInt(tolerance),
            ],
          ]
          : project === "LUCKIFY" || project === "KAI" || project === "BYZANLINK"
            ? [
              [
                tokenPriceFeed,
                parseInt(normalisationFactorToken),
                parseInt(tolerance),
              ],
            ]
            : [
              [
                tokenPriceFeed,
                parseInt(normalisationFactorToken),
                parseInt(normalisationFactorNFT),
                parseInt(tolerance),
              ],
            ];
      let dataInstitution = [
        [
          tokenPriceFeed,
          parseInt(normalisationFactorToken),
          parseInt(tolerance),
        ],
      ];
      console.log(
        contractAddress,
        data,
        "0xa048E46C35cf210bB0d5bb46b2DD06828Ef17893"
      );

      const createround1 = await contract.methods
        .setTokenPriceFeed(contractAddress, data)
        .send({ from: account })
        .on("transactionHash", (tx) => {
          return tx.transactionHash;
        });

      if (createround1) {
        // console.log(contractAddress, dataInstitution, "data institution");

        // const createroundInstitution = await contractInstitution.methods
        //   .setTokenPriceFeed(contractAddress, dataInstitution)
        //   .send({ from: account })
        //   .on("transactionHash", (tx) => {
        //     return tx.transactionHash;
        //   });
        // if (createroundInstitution) {
        handleClose();
        handleShow1();
        setLoader(false);
        // }
      }
    } catch (e) {
      handleClose();
      handleShow1();
      setLoader(false);
      console.log(e, "errrorooro");
    }
  };

  // List of tokens that require normalization factors
  const requiresNormalizationFactors = (symbol, address) => {
    const normalizedSymbol = symbol?.toUpperCase() || "";
    const normalizedAddress =
      address?.[0]?.toLowerCase() || address?.toLowerCase() || "";

    const specialSymbols = ["ETH", "USDC", "USDT", "WBTC", "LINK", "UNI"];
    const specialAddresses = [
      "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
      "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
      "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
      "0xdac17f958d2ee523a2206206994597c13d831ec7",
      "0x514910771af9ca656af840dff83e8264ecf986ca",
      "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
    ];

    return (
      specialSymbols.includes(normalizedSymbol) ||
      specialAddresses.includes(normalizedAddress)
    );
  };

  // Validate Ethereum address format
  const isValidEthereumAddress = (address) => {
    if (!address) return false;
    const ethAddress = Array.isArray(address) ? address[0] : address;
    return /^0x[a-fA-F0-9]{40}$/.test(ethAddress);
  };

  // Validate positive number
  const isValidPositiveNumber = (value) => {
    if (!value) return false;
    const num = parseFloat(value);
    return !isNaN(num) && num > 0;
  };

  // Validate integer
  const isValidInteger = (value) => {
    if (!value) return false;
    const num = parseInt(value, 10);
    return !isNaN(num) && num.toString() === value.toString() && num >= 0;
  };

  const ValidateForm = () => {
    let errors = {};
    let isValid = true;

    // ==================== COMMON VALIDATIONS (Both Manual & Automated) ====================

    // Validate Contract Address
    if (
      !contractAddress ||
      (Array.isArray(contractAddress) && contractAddress[0] === "")
    ) {
      isValid = false;
      errors["address"] = "*Please enter a valid Contract Address";
    } else if (!isValidEthereumAddress(contractAddress)) {
      isValid = false;
      errors["address"] = "*Invalid Ethereum address format";
    }

    // Validate Token Symbol
    if (!tokenSymbol || tokenSymbol.trim() === "") {
      isValid = false;
      errors["symbol"] = "*Please enter a Token Symbol";
    } else if (tokenSymbol.length > 10) {
      isValid = false;
      errors["symbol"] = "*Token Symbol must be less than 10 characters";
    }

    // Validate Token Decimals
    if (!tokenDecimals || tokenDecimals.toString().trim() === "") {
      isValid = false;
      errors["decimals"] = "*Please enter Token Decimals";
    } else if (!isValidInteger(tokenDecimals)) {
      isValid = false;
      errors["decimals"] = "*Token Decimals must be a valid integer (0-18)";
    } else if (parseInt(tokenDecimals) > 18) {
      isValid = false;
      errors["decimals"] = "*Token Decimals cannot exceed 18";
    }

    // ==================== AUTOMATED TAB VALIDATIONS ====================
    if (isAutomated) {
      if (!croppedImage) {
        isValid = false;
        errors["image"] = "*Please upload a token image";
      }
      // Validate CMC Symbol
      if (!cmcSymbol || cmcSymbol.trim() === "") {
        isValid = false;
        errors["cmcSymbol"] = "*Please enter Symbol on CMC";
      }

      // Validate UCID on CMC
      if (!cmcUCID || cmcUCID.trim() === "") {
        isValid = false;
        errors["cmcUCID"] = "*Please enter UCID on CMC";
      } else if (!isValidPositiveNumber(cmcUCID)) {
        isValid = false;
        errors["cmcUCID"] = "*UCID must be a valid positive number";
      }

      // Validate Slippage Tolerance
      if (!tolerance || tolerance.toString().trim() === "") {
        isValid = false;
        errors["tolerance"] = "*Please enter Slippage Tolerance";
      } else if (!isValidPositiveNumber(tolerance)) {
        isValid = false;
        errors["tolerance"] =
          "*Slippage Tolerance must be a valid positive number";
      }

      // Validate Price Feed Contract
      if (!tokenPriceFeed || tokenPriceFeed.trim() === "") {
        isValid = false;
        errors["priceFeed"] = "*Please enter Price Feed Contract address";
      } else if (!isValidEthereumAddress(tokenPriceFeed)) {
        isValid = false;
        errors["priceFeed"] = "*Invalid Price Feed Contract address format";
      }

      // Validate Normalization Factors for Automated (Always Required)
      if (
        !normalisationFactorToken ||
        normalisationFactorToken.toString().trim() === ""
      ) {
        isValid = false;
        errors["NFToken"] = "*Please enter Normalization Factor for Token";
      } else if (!isValidPositiveNumber(normalisationFactorToken)) {
        isValid = false;
        errors["NFToken"] =
          "*Normalization Factor Token must be a valid positive number";
      }

      if (
        project !== "KAI" &&
        (!normalisationFactorNFT ||
          normalisationFactorNFT.toString().trim() === "")
      ) {
        isValid = false;
        errors["NFNFT"] = "*Please enter Normalization Factor for NFT";
      } else if (
        project !== "KAI" &&
        !isValidPositiveNumber(normalisationFactorNFT)
      ) {
        isValid = false;
        errors["NFNFT"] =
          "*Normalization Factor NFT must be a valid positive number";
      }
    }

    // ==================== MANUAL TAB VALIDATIONS ====================
    if (!isAutomated) {
      // Check if normalization factors are required for specific tokens
      if (requiresNormalizationFactors(tokenSymbol, contractAddress)) {
        // For MATCHAIN, NFT factor is not needed
        if (project !== "MATCHAIN") {
          if (
            !normalisationFactorToken ||
            normalisationFactorToken.toString().trim() === ""
          ) {
            isValid = false;
            errors["NFToken"] = "*Please enter Normalization Factor for Token";
          } else if (!isValidPositiveNumber(normalisationFactorToken)) {
            isValid = false;
            errors["NFToken"] =
              "*Normalization Factor Token must be a valid positive number";
          }
        }

        // For LUCKIFY and KAI, NFT factor is not needed
        if (project !== "LUCKIFY" && project !== "KAI") {
          if (
            !normalisationFactorNFT ||
            normalisationFactorNFT.toString().trim() === ""
          ) {
            isValid = false;
            errors["NFNFT"] = "*Please enter Normalization Factor for NFT";
          } else if (!isValidPositiveNumber(normalisationFactorNFT)) {
            isValid = false;
            errors["NFNFT"] =
              "*Normalization Factor NFT must be a valid positive number";
          }
        }
      }
    }

    setErrors(errors);
    return isValid;
  };

  // const calculateCMCDetails = async (contractAddress) => {
  //   try {
  //     const res = await axios.get(
  //       "https://pro-api.coinmarketcap.com/v2/cryptocurrency/info",
  //       {
  //         params: { address: contractAddress[0] },
  //         headers: { "X-CMC_PRO_API_KEY": CMC_API_KEY },
  //       }
  //     );
  //     console.log("response from coingecko: waleed", res);
  //     setCmcSymbol(res.data.data.symbol);
  //     setCmcUCID(res.data.data.id);
  //   } catch (e) {
  //     console.log(e, "error");
  //   }
  // };

  useEffect(() => {
    if (tokenSymbol && key) {
      setLoader(true);
      //   //calculate CMC symbol / CMC UCID for automated tokens
      // if (isAutomated && contractAddress) {
      //   calculateCMCDetails(contractAddress);
      // }
      const NFToken = getNormalizationFactorToken(tokenSymbol);

      const NFNFT = getNormalizationFactorNFT(tokenSymbol);

      const Tol = getTolerance(tokenSymbol);

      const TPF = getPriceFeed(tokenSymbol);
      const CmcSymbol = getCmcSymbol(tokenSymbol);
      const CmcUCID = getCmcUCID(tokenSymbol);
      setCmcSymbol(CmcSymbol);
      setCmcUCID(CmcUCID);

      setNormalisationFactorToken(NFToken);
      setNormalisationFactorNFT(NFNFT);
      setTolerance(Tol);
      setTokenPriceFeed(TPF);
      setLoader(false);
    }
  }, [tokenSymbol, isAutomated, key, contractAddress]);

  const getNormalizationFactorToken = (tokenSym) => {
    const tokenData = tokensPriceFeed?.tokens?.find(
      (token) => token.name === tokenSym?.toUpperCase()
    );
    return tokenData?.networks?.[chainNetwork]?.normalizationFactorToken || "";
  };

  const getNormalizationFactorNFT = (tokenSym) => {
    const tokenData = tokensPriceFeed?.tokens?.find(
      (token) => token.name === tokenSym?.toUpperCase()
    );
    return tokenData?.networks?.[chainNetwork]?.normalizationFactorNFT || "";
  };

  const getTolerance = (tokenSym) => {
    const tokenData = tokensPriceFeed?.tokens?.find(
      (token) => token.name === tokenSym?.toUpperCase()
    );
    return tokenData?.networks?.[chainNetwork]?.tolerance || "";
  };

  const getPriceFeed = (tokenSym) => {
    const tokenData = tokensPriceFeed?.tokens?.find(
      (token) => token.name === tokenSym?.toUpperCase()
    );
    return tokenData?.networks?.[chainNetwork]?.priceFeed || "";
  };
  const getCmcSymbol = (tokenSym) => {
    const tokenData = tokensPriceFeed?.tokens?.find(
      (token) => token.name === tokenSym?.toUpperCase()
    );
    return tokenData?.networks?.[chainNetwork]?.symbol || "";
  };
  const getCmcUCID = (tokenSym) => {
    const tokenData = tokensPriceFeed?.tokens?.find(
      (token) => token.name === tokenSym?.toUpperCase()
    );
    console.log(tokenData, '0xdac17f958d2ee523a2206206994597c13d831ec70xdac17f958d2ee523a2206206994597c13d831ec7');

    return tokenData?.networks?.[chainNetwork]?.UCID || "";
  };

  return (
    <>
      {loader && <Loader />}
      <section className="salesround allpremiumprojects">
        <div className="custom-container">
          <div className="main-heading">
            <h6>Token Settings</h6>
            <div className="parent-btns tokensettingsbtns">
              {!isAutomated && (
                <div className="dropdown">
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div className="projectmain">
                      {selectedItem.imgSrc && (
                        <img
                          src={selectedItem.imgSrc}
                          alt="projectimg"
                          className="projectimg"
                          width={24}
                        />
                      )}
                      <p className="projectpara">{selectedItem.text}</p>
                    </div>
                    <img
                      src="/assets/arrow-down.svg"
                      alt="arrow-down"
                      className="img-fluid"
                    />
                  </button>
                  <ul className="dropdown-menu">
                    {PROJECT_MAPPING_Fixed.map((project) => (
                      <li key={project.value}>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() =>
                            handleItemClick(project.imageSrc, project.value)
                          }
                        >
                          <div className="projectmain">
                            <img
                              src={project.imageSrc}
                              alt="projectimg"
                              className="projectimg"
                              width={24}
                            />
                            <p className="projectpara">{project.label}</p>
                          </div>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <div className="custom-option-field">
                <input
                  type="search"
                  placeholder="Search by address"
                  className="inputsizee"
                  value={isAutomated ? automatedSearch : search}
                  onChange={(e) => {
                    if (isAutomated) {
                      setAutomatedSearch(e.target.value);
                    } else {
                      setSearch(e.target.value);
                    }
                  }}
                />
                <svg
                  className=" search-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M10.0006 8.73281C9.37544 9.70902 8.28128 10.356 7.036 10.356C5.09309 10.356 3.51806 8.78102 3.51806 6.83812C3.51806 4.89522 5.09309 3.32018 7.036 3.32018C8.9789 3.32018 10.5539 4.89522 10.5539 6.83812C10.5539 7.39671 10.4237 7.9249 10.192 8.39399L12.5735 8.39399C12.7123 7.89913 12.7865 7.37729 12.7865 6.83812C12.7865 3.66222 10.2119 1.08765 7.036 1.08765C3.8601 1.08765 1.28552 3.66222 1.28552 6.83812C1.28552 10.014 3.8601 12.5886 7.036 12.5886C8.66122 12.5886 10.129 11.9144 11.1748 10.8304L10.0006 8.73281Z"
                    fill="#0A2931"
                  />
                  <path
                    d="M14.9075 16.835L15.6358 14.1168L10.0372 8.66481L9.30888 11.383L14.9075 16.835Z"
                    fill="#0A2931"
                  />
                </svg>
              </div>
              {/* <div class="dropdown">
                <button
                  class="btn btn-secondary dropdown-toggle dsfdsf"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {statusFilter == "active"
                    ? "Active"
                    : statusFilter == "inactive"
                    ? "Inactive"
                    : "All"}
                  <img
                    src="\assets\arrow-down.svg"
                    alt="img"
                    className="img-fluid"
                  />
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => setStatusFilter("")}
                    >
                      All
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => setStatusFilter("active")}
                    >
                      Active
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => setStatusFilter("inactive")}
                    >
                      Inactive
                    </a>
                  </li>
                </ul>
              </div> */}
              {isAdmin && (
                <button
                  className="zdgvzfxv"
                  onClick={isAutomated ? handleShowAutoAdd : handleShow}
                >
                  Add Token
                </button>
              )}
            </div>
          </div>
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="projectstabs"
          >
            <Tab eventKey="manualprivatesales" title="Manual Private Sales">
              <DataTable
                tokenData={tokenData}
                toggleStatus={toggleStatus}
                setOrderDirection={setOrderDirection}
                setOrderField={setOrderField}
                isAdmin={isAdmin}
              />
            </Tab>
            <Tab
              eventKey="automatedprivatesales"
              title="Automated Private Sales"
            >
              <DataTable
                tokenData={autotokensData}
                toggleStatus={toggleStatusAutomated}
                setOrderDirection={setAutomatedOrderDirection}
                setOrderField={setAutomatedOrderField}
                isAdmin={isAdmin}
                isAutomated={true}
              />
            </Tab>
          </Tabs>
        </div>
      </section>
      <Modal
        className="add-mega-modal global-modal-scss"
        show={showAutoAdd}
        onHide={handleCloseAutoAdd}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Token</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="tokken_mainss">
            <div className="tokken_details">
              <div className="tokken_inner">
                {croppedImage ? (
                  <img
                    src={croppedImage}
                    alt="token"
                    style={{
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div className="upload-placeholder-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="38"
                      height="38"
                      viewBox="0 0 38 38"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_910_5479)">
                        <path
                          d="M27.6332 37.9994C27.3672 37.9994 27.0948 37.9662 26.8257 37.8949L2.34258 31.3383C0.664251 30.876 -0.336416 29.1375 0.103751 27.4592L3.19283 15.9452C3.30683 15.5224 3.74067 15.277 4.16183 15.3847C4.58458 15.4971 4.83475 15.9325 4.72233 16.3537L1.63483 27.8645C1.41475 28.7037 1.91825 29.5777 2.759 29.8104L27.2326 36.3638C28.0733 36.5855 28.941 36.0852 29.1595 35.2492L30.3961 30.667C30.5101 30.2442 30.9439 29.9925 31.3667 30.1081C31.7894 30.2221 32.038 30.6575 31.9256 31.0787L30.6906 35.6545C30.3185 37.0637 29.036 37.9994 27.6332 37.9994Z"
                          fill="black"
                        />
                        <path
                          d="M34.832 28.4993H9.4987C7.75228 28.4993 6.33203 27.0791 6.33203 25.3327V6.33268C6.33203 4.58627 7.75228 3.16602 9.4987 3.16602H34.832C36.5784 3.16602 37.9987 4.58627 37.9987 6.33268V25.3327C37.9987 27.0791 36.5784 28.4993 34.832 28.4993ZM9.4987 4.74935C8.62628 4.74935 7.91536 5.46027 7.91536 6.33268V25.3327C7.91536 26.2051 8.62628 26.916 9.4987 26.916H34.832C35.7044 26.916 36.4154 26.2051 36.4154 25.3327V6.33268C36.4154 5.46027 35.7044 4.74935 34.832 4.74935H9.4987Z"
                          fill="black"
                        />
                        <path
                          d="M14.2487 14.2493C12.5023 14.2493 11.082 12.8291 11.082 11.0827C11.082 9.33627 12.5023 7.91602 14.2487 7.91602C15.9951 7.91602 17.4154 9.33627 17.4154 11.0827C17.4154 12.8291 15.9951 14.2493 14.2487 14.2493ZM14.2487 9.49935C13.3763 9.49935 12.6654 10.2103 12.6654 11.0827C12.6654 11.9551 13.3763 12.666 14.2487 12.666C15.1211 12.666 15.832 11.9551 15.832 11.0827C15.832 10.2103 15.1211 9.49935 14.2487 9.49935Z"
                          fill="black"
                        />
                        <path
                          d="M7.23542 26.8067C7.03276 26.8067 6.83009 26.7292 6.67492 26.5756C6.36617 26.2668 6.36617 25.7649 6.67492 25.4562L14.153 17.9781C15.0492 17.0819 16.6151 17.0819 17.5113 17.9781L19.7374 20.2042L25.8998 12.8101C26.3478 12.2733 27.0065 11.9614 27.7079 11.9551H27.7253C28.4188 11.9551 29.0759 12.2559 29.5288 12.7832L37.8096 22.4447C38.0946 22.7756 38.0566 23.2759 37.7241 23.5609C37.3932 23.8459 36.8944 23.8095 36.6078 23.4754L28.327 13.8139C28.1734 13.6366 27.9613 13.5384 27.7253 13.5384C27.5607 13.5242 27.2709 13.6382 27.1173 13.8234L20.3993 21.8842C20.2568 22.0552 20.0493 22.1581 19.8261 22.1676C19.6013 22.1834 19.3875 22.0947 19.2308 21.9364L16.3918 19.0975C16.0926 18.7998 15.5717 18.7998 15.2724 19.0975L7.79434 26.5756C7.64075 26.7292 7.43809 26.8067 7.23542 26.8067Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_910_5479">
                          <rect width="38" height="38" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                )}
              </div>

              <div>
                <h3>
                  Project Image<span>*</span>
                </h3>
                <p>800×800 resolution • Max 3MB • JPEG/PNG</p>

                <input
                  type="file"
                  accept="image/jpeg, image/png"
                  onChange={onImageUpload}
                  id="imgUpload"
                  hidden
                />

                <button
                  onClick={() => document.getElementById("imgUpload").click()}
                >
                  {croppedImage ? "Change Image" : "Upload Image"}
                </button>
                <div style={{ position: "unset" }} className="text-danger ">
                  <small>{errors.image}</small>
                </div>
              </div>
            </div>

            <div className="inputs_mains">
              <input
                type="text"
                value={contractAddress}
                onChange={(e) => {
                  handleContractChange(e);
                  setErrors((prev) => ({ ...prev, address: "" }));
                }}
                placeholder="Contract Address"
              />
              <div style={{ position: "unset" }} className="text-danger ">
                <small className="small">{errors.address}</small>
              </div>
              <div className="tokken_input">
                <div>
                  <input
                    type="text"
                    value={tokenSymbol}
                    onChange={(e) => {
                      const symb = e.target.value;
                      setTokenSymbol(symb);
                      setErrors((prev) => ({ ...prev, symbol: "" }));
                    }}
                    placeholder="Token Symbol"
                  />
                  <div style={{ position: "unset" }} className="text-danger ">
                    <small>{errors.symbol}</small>
                  </div>
                </div>
                <div>
                  <input
                    type="text"
                    value={tokenDecimals}
                    onChange={(e) => {
                      setTokenDecimals(e.target.value);
                      setErrors((prev) => ({ ...prev, decimals: "" }));
                    }}
                    placeholder="Token Decimals"
                  />
                  <div style={{ position: "unset" }} className="text-danger ">
                    <small>{errors.decimals}</small>
                  </div>
                </div>
              </div>

              <div className="tokken_input">
                <div>
                  <input
                    type="text"
                    value={cmcSymbol}
                    onChange={(e) => {
                      setCmcSymbol(e.target.value);
                      setErrors((prev) => ({ ...prev, cmcSymbol: "" }));
                    }}
                    placeholder="Symbol on CMC"
                  />
                  <div style={{ position: "unset" }} className="text-danger ">
                    <small>{errors.cmcSymbol}</small>
                  </div>
                </div>
                <div>
                  <input
                    type="text"
                    value={cmcUCID}
                    onChange={(e) => {
                      setCmcUCID(e.target.value);
                      setErrors((prev) => ({ ...prev, cmcUCID: "" }));
                    }}
                    placeholder="UCID on CMC"
                  />
                  <div style={{ position: "unset" }} className="text-danger ">
                    <small>{errors.cmcUCID}</small>
                  </div>
                </div>
              </div>

              <div className="tokken_input">
                <div>
                  <input
                    type="text"
                    value={tolerance}
                    onChange={(e) => {
                      setTolerance(e.target.value);
                      setErrors((prev) => ({ ...prev, tolerance: "" }));
                    }}
                    placeholder="Set Slippage Tolerance"
                  />
                  <div style={{ position: "unset" }} className="text-danger ">
                    <small>{errors.tolerance}</small>
                  </div>
                </div>
                <div>
                  <input
                    type="text"
                    value={tokenPriceFeed}
                    onChange={(e) => {
                      setTokenPriceFeed(e.target.value);
                      setErrors((prev) => ({ ...prev, priceFeed: "" }));
                    }}
                    placeholder="Pricefeed contract"
                  />
                  <div style={{ position: "unset" }} className="text-danger ">
                    <small>{errors.priceFeed}</small>
                  </div>
                </div>
              </div>

              <div className="tokken_input lastinput">
                <div>
                  <input
                    type="text"
                    value={normalisationFactorToken}
                    onChange={(e) => {
                      setNormalisationFactorToken(e.target.value);
                      setErrors((prev) => ({ ...prev, NFToken: "" }));
                    }}
                    placeholder="Normalization factor token"
                  />
                  <div style={{ position: "unset" }} className="text-danger ">
                    <small>{errors.NFToken}</small>
                  </div>
                </div>
                {project === "KAI" ? null : (
                  <div>
                    <input
                      type="text"
                      value={normalisationFactorNFT}
                      onChange={(e) => {
                        setNormalisationFactorNFT(e.target.value);
                        setErrors((prev) => ({ ...prev, NFNFT: "" }));
                      }}
                      placeholder="Normalization factor nft"
                    />
                    <div style={{ position: "unset" }} className="text-danger ">
                      <small>{errors.NFNFT}</small>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="twice-btn">
            <button onClick={handleCloseAutoAdd} className="btn-cancel">
              Back
            </button>
            <button className="btn-add" onClick={addAutomatedToken}>
              Add
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* 🔹 Crop Modal */}
      <Modal
        className="publish-modall"
        show={showCropModal}
        onHide={() => setShowCropModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Crop Image</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="publish_modal">
            <div className="croopppy">
              {imageSrc && (
                <div
                  className="crop-container inercrop"
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "240px",
                    background: "#E7EEF2",
                    borderRadius: "4px",
                    overflow: "hidden",
                  }}
                >
                  <Cropper
                    image={imageSrc}
                    crop={crop}
                    zoom={zoom}
                    aspect={1}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                  />
                </div>
              )}

              <p>Drag to reposition image</p>

              {/* 🔹 Zoom Slider */}
              <div className="zoom-slider">
                <h5>Zoom</h5>
                <input
                  type="range"
                  min={1}
                  max={3}
                  step={0.1}
                  value={zoom}
                  onChange={(e) => setZoom(Number(e.target.value))}
                  style={{
                    width: "100%",
                    height: "8px",
                    borderRadius: "10px",
                    appearance: "none",
                  }}
                />
              </div>

              {/* 🔹 Crop Buttons */}
              <div className="publish_buttons">
                <button
                  className="cancel_button"
                  onClick={() => setShowCropModal(false)}
                >
                  Cancel
                </button>
                <button className="confirm_button" onClick={handleSave}>
                  Save Cropped Image
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Token</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="text"
                  placeholder="Enter token contract address"
                  value={contractAddress}
                  onChange={(e) => {
                    handleContractChange(e);
                  }}
                />
                {/* <label>Contract Address</label> */}
              </div>
            </div>
            <div style={{ position: "unset" }} className="text-danger ">
              <small>{errors.address}</small>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="text"
                  placeholder="Enter Token Symbol"
                  value={tokenSymbol}
                  onChange={(e) => {
                    const symb = e.target.value;
                    setTokenSymbol(symb);
                  }}
                />
                {/* <label>Token Symbol</label> */}
              </div>
            </div>
            <div style={{ position: "unset" }} className="text-danger ">
              <small>{errors.symbol}</small>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="text"
                  placeholder="Enter Token Decimals"
                  value={tokenDecimals}
                  onChange={(e) => {
                    setTokenDecimals(e.target.value);
                  }}
                />
                {/* <label>Token Decimals</label> */}
              </div>
            </div>
            <div style={{ position: "unset" }} className="text-danger ">
              <small>{errors.decimals}</small>
            </div>
            {tokenSymbol == "eth" ||
              tokenSymbol == "ETH" ||
              contractAddress == "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE" ||
              contractAddress == "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599" ||
              contractAddress == "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48" ||
              contractAddress == "0xdAC17F958D2ee523a2206206994597C13D831ec7" ||
              contractAddress == "0x514910771AF9Ca656af840dff83E8264EcF986CA" ||
              contractAddress == "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984" ||
              tokenSymbol == "usdc" ||
              tokenSymbol == "USDC" ||
              tokenSymbol == "USDT" ||
              tokenSymbol == "usdt" ||
              tokenSymbol == "wbtc" ||
              tokenSymbol == "WBTC" ||
              tokenSymbol == "LINK" ||
              tokenSymbol == "link" ||
              tokenSymbol == "UNI" ||
              tokenSymbol == "uni" ? (
              <>
                {project === "MATCHAIN" ? null : (
                  <div className="option-field">
                    <div className="material-textfield">
                      <input
                        type="text"
                        placeholder="Normalisation Factor TOKEN"
                        value={normalisationFactorToken}
                      // onChange={(e) => {
                      //   const input = e.target.value;
                      //   const isValidInput =
                      //     /^([0-9]+)?(\.[0-9]*)?$/.test(input) &&
                      //     parseFloat(input) >= 0;
                      //   if (isValidInput || input === "") {
                      //     setNormalisationFactorToken(input);
                      //   }
                      // }}
                      />
                      <label className="textttcolor">Normalisation Factor TOKEN</label>
                    </div>
                  </div>
                )}
                <div style={{ position: "unset" }} className="text-danger ">
                  <small>{errors.NFToken}</small>
                </div>
                {project === "LUCKIFY" || project === "KAI" ? null : (
                  <div className="option-field">
                    <div className="material-textfield">
                      <input
                        type="text"
                        placeholder="Normalisation Factor NFT"
                        value={normalisationFactorNFT}
                      // value={normalisationFactorNFT}

                      // onChange={(e) => {
                      //   const input = e.target.value;
                      //   const isValidInput =
                      //     /^([0-9]+)?(\.[0-9]*)?$/.test(input) &&
                      //     parseFloat(input) >= 0;

                      //   if (isValidInput || input === "") {
                      //     setNormalisationFactorNFT(input);
                      //   }
                      // }}
                      />
                      <label className="textttcolor">Normalisation Factor NFT</label>
                    </div>
                  </div>
                )}
                <div style={{ position: "unset" }} className="text-danger ">
                  <small>{errors.NFNFT}</small>
                </div>

                <div className="option-field">
                  <div className="material-textfield">
                    <input
                      type="text"
                      placeholder={`Enter Tolerance`}
                      // value={getTolerance(tokenSymbol)}

                      value={tolerance}
                    // onChange={(e) => {
                    //   const input = e.target.value;
                    //   setTolerance(input);
                    // }}
                    />
                    <label className="textttcolor">Tolerance</label>
                  </div>
                </div>
                <div style={{ position: "unset" }} className="text-danger ">
                  <small>{errors.tolerance}</small>
                </div>

                <div className="option-field">
                  <div className="material-textfield">
                    <input
                      type="text"
                      placeholder={`Enter Price Feed Address`}
                      // value={getPriceFeed(tokenSymbol)}

                      value={tokenPriceFeed}
                    // onChange={(e) => {
                    //   const input = e.target.value;
                    //   setTokenPriceFeed(input);
                    // }}
                    />
                    <label className="textttcolor">Price Feed Address</label>
                  </div>
                </div>
                <div style={{ position: "unset" }} className="text-danger ">
                  <small>{errors.priceFeed}</small>
                </div>
              </>
            ) : null}
          </div>
          <div className="twice-btn">
            <button onClick={handleClose} className="btn-cancel">
              Back
            </button>
            <button
              className="btn-add"
              onClick={() => {
                addToken();
              }}
            >
              Add
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="connectwallet-modal buy-modal"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Token</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buy-modal">
            <img src="/assets/happy.svg" alt="img" className="img-fluid" />
            <p>Token added successfully</p>
            <button onClick={handleClose1} className="btn-common">
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Tokensettings;